import { lt } from '@mews/framework';
import { DropDownButton, IconName, DropdownItem, Icon } from '@optimus-web/core';

export const AddButton = () => (
    <DropDownButton
        size="small"
        label={lt('ContractGuestProfileTemplateAddButtonLabel')}
        icon={IconName.PlusSimple}
        type="button"
    >
        <DropdownItem
            leftDetail={<Icon value={IconName.ActionLog} />}
            label={lt('ContractGuestProfileGenerateFromTemplateButtonLabel')}
            onClick={() => {}}
        />
        <DropdownItem
            leftDetail={<Icon value={IconName.Upload} />}
            label={lt('ContractGuestProfileUploadButtonLabel')}
            onClick={() => {}}
        />
    </DropDownButton>
);
